var map = {
	"./gallery_00.jpg": 2067,
	"./gallery_01.jpg": 2068,
	"./gallery_02.jpg": 2069,
	"./gallery_03.jpg": 2070,
	"./gallery_04.jpg": 2071,
	"./gallery_05.jpg": 2072,
	"./gallery_06.jpg": 2073,
	"./gallery_07.jpg": 2074,
	"./gallery_08.jpg": 2075,
	"./gallery_09.jpg": 2076
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2066;